export function isArrayEmpty(array: unknown[] | null | undefined): boolean {
  return !(array && array.length >= 1);
}
